const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";
const isProduction = process.env.NODE_ENV === "production";

function buildLedgerEntryQuery(entry) {
  if (!entry.clientId || !entry.entryKey) {
    throw new Error("clientledger production writes require clientId and entryKey.");
  }

  return `?clientId=${encodeURIComponent(entry.clientId)}&entryKey=${encodeURIComponent(entry.entryKey)}`;
}

async function getClientLedger(clientId = "") {
  const query = clientId ? `?clientId=${encodeURIComponent(clientId)}` : "";
  const response = await fetch(`${baseUrl}clientledger/${query}`);
  if (response.ok) return response.json();
  throw new Error(`HTTP ${response.status}: ${response.statusText}`);
}

async function saveClientLedgerEntry(entry, isNew = false) {
  const resourcePath = isProduction
    ? `clientledger/${!isNew && entry.id ? buildLedgerEntryQuery(entry) : ""}`
    : `clientledger/${encodeURIComponent(!isNew && entry.id ? entry.id : "")}`;

  const response = await fetch(`${baseUrl}${resourcePath}`, {
    method: !isNew && entry.id ? "PUT" : "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(entry),
  });
  if (response.ok) return response.json();
  throw new Error(`HTTP ${response.status}: ${response.statusText}`);
}

async function deleteClientLedgerEntry(entry) {
  const resourcePath = isProduction
    ? `clientledger/${buildLedgerEntryQuery(entry)}`
    : `clientledger/${encodeURIComponent(entry.id)}`;

  const response = await fetch(`${baseUrl}${resourcePath}`, {
    method: "DELETE",
    headers: { "content-type": "application/json" },
  });
  if (response.ok) return response.json();
  throw new Error(`HTTP ${response.status}: ${response.statusText}`);
}

export default { getClientLedger, saveClientLedgerEntry, deleteClientLedgerEntry };
